'use client';

import type { BlocksContent } from '@strapi/blocks-react-renderer';

import { getPlainText } from './getPlainText';

export const getToySizeFromDescription = (description: BlocksContent) => {
  if (!description) {
    return '';
  }

  const sizeRegex = /(\d+) см./;
  const sizeMatch = getPlainText(description).match(sizeRegex);

  return sizeMatch ? sizeMatch[1] : '';
};
